import { authApi } from '@/utils/axios-config'

const apiBase = 'my/geo';

export default {
    getOeamtcBase() {
        return authApi.get(`${apiBase}/favorites/my-oeamtc-base`);
    },
    addOeamtcBase(id) {
        return authApi.put(`${apiBase}/favorites/my-oeamtc-base`, 
            {
                    poiId: id
            }
        )
    },
    removeOeamtcBase() {
        return authApi.delete(`${apiBase}/favorites/my-oeamtc-base`)
    },
}